// client, index, and server use this exported BASE_NAME for defining the module.
// When creating a new module, copy the example folder and update the BASE_NAME as desired
export const BASE_NAME = 'tax';

/* The title is default 'Stride Health - [BASE_NAME]' and adding the BASE_TITLE
   export will override the BASE_NAME. If BASE_TITLE is an empty string, it will
   have the title as just 'Stride Health'
*/
// export const BASE_TITLE = '';
